import { makeObservable, action, observable } from 'mobx';
import StoreUtils from './store-utils';

export const StoreVersion = {
    INITIAL: 'INITIAL',
};

class ImageStore {
    version = StoreVersion.INITIAL;
    db;
    id = Date.now();

    constructor(userId) {
        console.warn('ImageStore constructor id:', this.id);

        this.db = StoreUtils.createDexieUserDB(userId, 'ImageStore');

        this.db.version(1).stores({
            images: 'imageName, data, eTag',
        });

        makeObservable(this, {
            version: observable,
            migrate: action.bound,
        });
    }

    async clearStore() {
        console.warn('Clearing IndexedDB ImageStore...');
        await this.db.images.clear();
    }

    async deleteDatabase() {
        console.warn('Deleting IndexedDB database...');
        await this.db.delete();
    }

    // Save image and eTag to IndexedDB
    async saveImageToIndexedDB(imageName, imageData, eTag) {
        console.warn(`ImageStore saveImageToIndexedDB: ${imageName}`);
        try {
            return await this.db.images.put({ imageName, data: imageData, eTag });
        } catch (error) {
            console.error('ImageStore Dexie put error:', error);
            const isQuotaError =
                error?.name === 'QuotaExceededError' ||
                error?.inner?.name === 'QuotaExceededError' ||
                String(error?.message || '').includes('QuotaExceededError');

            if (!isQuotaError) {
                return false;
            }

            try {
                console.warn('ImageStore quota exceeded. Clearing images cache and retrying once.');
                await this.db.images.clear();
                return await this.db.images.put({ imageName, data: imageData, eTag });
            } catch (retryError) {
                console.error('ImageStore retry after cache clear failed:', retryError);
                return false;
            }
        }
    }

    // Retrieve image and eTag from IndexedDB
    async getImageFromIndexedDB(imageName) {
        console.log(`ImageStore getImageFromIndexedDB: ${imageName}`);
        // Retrieve both the image data and the eTag
        return this.db.images.get(imageName).then((imageObj) => {
            if (imageObj) {
                // Return both data and eTag
                return { data: imageObj.data, eTag: imageObj.eTag };
            }
            return null;
        });
    }

    migrate() {
        console.warn('ImageStore migrate');
        switch (this.version) {
            case StoreVersion.INITIAL:
                console.warn('ImageStore migrate version is INITIAL');
                break;
            default:
                break;
        }
        // Perform migrations on the Dexie DB if necessary
    }
}

const createImageStore = async (userId) => {
    const store = new ImageStore(userId);
    /// await store.initialize(); // Wait for the store to be initialized
    return store;
};

export default createImageStore;
